module.exports = __webpack_public_path__ + "img/life-preserver.d5a91355.svg";